import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    blockingOverlay: {
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        fontSize: "18px",
        zIndex: 100,
    },
    PageWrap: {
        background: "#f5f6fa",
        overflow: "hidden",
    },
    NewOrderPage: {
        width: "100vw",
        height: "100vh", // Set actual height, not just maxHeight
        maxHeight: "100vh",
        background: "#f5f6fa",
        padding: "20px 20px",
        display: "flex",
        margin: "0 auto",
        boxSizing: "border-box", // Include padding in height calculation
    },
    Categories: {
        width: "118px",
        padding: "0 10px 0 0",
        position: "relative",
        width: "10vw",
        "& .CategoriesTitle": {
            top: "50%",
            left: "-25px",
            color: "#271D1C",
            position: "absolute",
            fontSize: "10px",
            transform: "rotate(-90deg) translateY(-50%)",
            fontStyle: "normal",
            textAlign: "center",
            fontWeight: "700",
            lineHeight: "12px",
            textTransform: "uppercase",
        },
        "& .CategoriesList": {
            height: "95%",
        },
        "& .Category": {
            position: "relative",
            marginBottom: "8px",
            "& .Category__Name": {
                fontStyle: "normal",
                fontWeight: "700",
                fontSize: "8px",
                lineHeight: "10px",
                textTransform: "uppercase",
                color: "#FFFFFF",
                position: "absolute",
                bottom: 0,
                width: "100%",
                textAlign: "center",
                padding: "5px",
                color: "black",
            },
            "& .Category__Img": {
                width: "100px",
                height: "60px",
                background:
                    "linear-gradient(180deg, rgba(12, 12, 10, 0) 0%, rgba(12, 12, 10, 0.75) 100%)",
                borderRadius: "8px",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
            },
        },
    },
    CategoryViewWrapper: {
        flex: 1,
        minHeight: 0, // Allow flex item to shrink below its content size
        overflowY: "auto",
        overflowX: "hidden",
    },
    SubGroupText: {
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "8px",
        lineHeight: "10px",
        textTransform: "uppercase",
        color: "#FFFFFF",
        position: "absolute",
        bottom: 0,
        width: "100%",
        textAlign: "center",
        padding: "5px",
    },
    CategoryView: {
        flex: 1,
        width: "60vw",
        height: "calc(100vh - 40px)", // Full viewport minus padding (20px top + 20px bottom)
        maxHeight: "calc(100vh - 40px)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden", // Prevent the outer container from scrolling
        "& .ItemsList": {
            display: "flex",
            flexDirection: "row",
            paddingBottom: "5px",
            width: "100%", // Ensure full width usage
            minWidth: "100%", // Prevent shrinking
        },
        "& .CategoryView__Header": {
            marginBottom: "12px",
            flexShrink: 0, // Never shrink — grow to fit content
            "& .Header__Title": {
                marginRight: "12px",
                flexShrink: 0, // Don't shrink
                minWidth: "auto", // Take minimal needed space
                width: "auto", // Don't expand unnecessarily
                "&>div:first-child": {
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: "14px",
                    lineHeight: "17px",
                    textTransform: "uppercase",
                    color: "#e14954",
                    marginBottom: "2px",
                },
                "&>div:last-child": {
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: "10px",
                    lineHeight: "12px",
                    textTransform: "uppercase",
                    color: "rgba(39, 29, 28, 0.75)",
                },
            },
            "& .Subcatgories": {
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                width: "100%",
                height: "72px",
                "& .Subcategory": {
                    background:
                        "linear-gradient(180deg, rgba(12, 12, 10, 0) 0%, rgba(12, 12, 10, 0.75) 100%)",
                    borderRadius: "8px",
                    width: "56px",
                    height: "41px",
                    position: "relative",
                    marginRight: "8px",
                    overflow: "hidden",
                    "& .Subcategory__Name": {
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: "8px",
                        lineHeight: "10px",
                        textTransform: "uppercase",
                        color: "#FFFFFF",
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        textAlign: "center",
                        padding: "5px",
                    },
                    "& .Subcategory__Img": {
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        width: "56px",
                        height: "41px",
                    },
                },
            },
        },
        "& .CategoryView__Main": {
            // Note: PosItemList uses Material-UI Grid, so we override grid display
            display: "block", // Let MUI Grid handle the layout
            borderLeft: "1px solid #ccc", // Left border
            borderRight: "1px solid #ccc", // Right border
            padding: "12px", // Add padding to separate border from content
            width: "100%", // Full width
            height: "auto", // Allow content to determine height
            minHeight: "100%", // Take at least full container height
            // Content will grow beyond container when there are many items
            "& .Item": {
                padding: "4px",
                display: "flex",
                background: "#FFFFFF",
                boxShadow:
                    "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
                borderRadius: "8px",
                "& .Img": {
                    width: "90px",
                    height: "69.38px",
                    borderRadius: "8px",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                },
                "& .MainDetails": {
                    flex: 1,
                    padding: "12px",
                    display: "flex",
                    flexDirection: "column",
                },
                "& .Name": {
                    fontStyle: "normal",
                    fontWeight: "600",
                    fontSize: "14px",
                    lineHeight: "17px",
                    color: "#271D1C",
                    marginBottom: "auto",
                },
                "& .SubDetails": {
                    display: "flex",
                    alignItems: "center",
                },
                "& .Price": {
                    fontStyle: "normal",
                    fontWeight: "400",
                    fontSize: "12px",
                    lineHeight: "15px",
                    textAlign: "center",
                    color: "#271D1C",
                    marginRight: "auto",
                },
                "& .Actions": {
                    "& .AddBtn": {
                        background: "none",
                        border: "none",
                        padding: 0,
                        margin: 0,
                        boxShadow: "none",
                        outline: "none",
                        fontSize: "25px",
                        cursor: "pointer",
                        width: "25px",
                        height: "25px",
                        display: "block",
                        "& i": {
                            color: "#6E7187",
                        },
                    },
                },
            },
        },
        "& .CategoryView__MainMenu": {
            display: "grid",
            gridTemplateColumns: "repeat(3, auto)", // Adjust the number of columns as needed
            columnGap: "12px",
            rowGap: "12px",
            "& .Item": {
                padding: "4px",
                display: "flex",
                minHeight: "200px",
                background: "#FFFFFF",
                boxShadow:
                    "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
                borderRadius: "8px",
                "& .Img": {
                    width: "120px",
                    height: "100.38px",
                    borderRadius: "8px",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                },
                "& .MainDetails": {
                    flex: 1,
                    padding: "12px",
                    display: "flex",
                    flexDirection: "column",
                },
                "& .Name": {
                    fontStyle: "normal",
                    fontWeight: "600",
                    fontSize: "14px",
                    lineHeight: "17px",
                    color: "#271D1C",
                    marginBottom: "auto",
                },
                "& .Description": {
                    fontStyle: "normal",
                    fontWeight: "600",
                    fontSize: "11px",
                    lineHeight: "17px",
                    color: "#271D1C",
                    marginBottom: "auto",
                },
                "& .SubDetails": {
                    display: "flex",
                    alignItems: "center",
                },
                "& .Price": {
                    fontStyle: "normal",
                    fontWeight: "400",
                    fontSize: "12px",
                    lineHeight: "15px",
                    textAlign: "center",
                    color: "#271D1C",
                    marginRight: "auto",
                },
                "& .Actions": {
                    "& .AddBtn": {
                        background: "none",
                        border: "none",
                        padding: 0,
                        margin: 0,
                        boxShadow: "none",
                        outline: "none",
                        fontSize: "25px",
                        cursor: "pointer",
                        width: "25px",
                        height: "25px",
                        display: "block",
                        "& i": {
                            color: "#6E7187",
                        },
                    },
                },
            },
        },
    },
    Order: {
        padding: "0 0 0 25px",
    },
    itemCardEnabled: {},
    itemCardDisabled: {
        color: "red",
        border: "2px solid red",
        borderRadius: "8px",
    },
    NotificationSnackbar: {
        width: "315px",
        height: "72px",
        background: "#FFFFFF",
        boxShadow:
            "0px 4px 15px rgba(249, 98, 83, 0.2), inset 4px -4px 0px #F96253",
        borderRadius: "8px",
        borderBottomLeftRadius: "5px",
    },
    NotificationSnackbarContent: {
        "& div": {
            position: "relative",
        },
        color: "black",
    },
    NotificationIcon: {
        width: "36px",
        height: "36px",
        borderRadius: "8px",
        background: "#F96253",
    },
    NotificationIconBox: {
        position: "absolute",
        width: "22px",
        height: "22px",
        top: "34.72%",
        left: "7.94%",
        right: "85.08%",
        bottom: "34.72%",
    },
    NotificationLabel: {
        left: "64px",
        bottom: "36px",
    },
}));
